import { lightTheme } from "../../theme/theme";
type Theme = typeof lightTheme;

export const ContactStyles = (theme: Theme, isMobile: boolean) => {
  return {
    // page wrapper
    wrap: {
      maxWidth: 1140,
      margin: "0 auto",
      padding: isMobile ? "24px 14px" : "40px 16px",
    } as React.CSSProperties,

    grid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1.2fr",
      gap: isMobile ? 16 : 20,
      alignItems: "start",
    } as React.CSSProperties,

    // LEFT (typography)
    headingEyebrow: {
      fontSize: 12,
      letterSpacing: 1,
      textTransform: "uppercase" as const,
      color: theme.text,
      fontWeight: 700,
      opacity: 0.9,
    } as React.CSSProperties,

    heading: {
      margin: "6px 0 10px",
      fontSize: isMobile ? 30 : 40,
      fontFamily: '"Playfair Display", Georgia, serif',
      fontWeight: 700,
      fontStyle: "italic",
      lineHeight: 1.12,
      color: theme.text,
    } as React.CSSProperties,

    row: {
      display: "grid",
      gap: isMobile ? 10 : 12,
      gridTemplateColumns: "1fr",
    } as React.CSSProperties,

    submitBtn: {
      marginTop: 8,
      padding: isMobile ? "12px 14px" : "10px 16px",
      borderRadius: 12,
      background: theme.color0,
      color: theme.color3,
      fontWeight: 800,
      border: `1px solid ${theme.border}`,
      cursor: "pointer",
      transition: "transform .12s ease, opacity .12s ease",
      width: isMobile ? "100%" : "auto",
    } as React.CSSProperties,

    submitBtnHover: { opacity: 0.95, transform: "translateY(-1px)" },
  };
};
